import { render } from "./LifeChurchReport.vue?vue&type=template&id=0b7098a0&scoped=true"
import script from "./LifeChurchReport.vue?vue&type=script&lang=js"
export * from "./LifeChurchReport.vue?vue&type=script&lang=js"

import "./LifeChurchReport.vue?vue&type=style&index=0&id=0b7098a0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0b7098a0"

export default script